"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HotPicks',
  props: ['itemDetail'],
  data: function data() {
    return {
      dataList: []
    };
  },
  mounted: function mounted() {},
  methods: {}
};